let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("699ae"), load("i7QCq"), load("fZyYv")]).then(() => parcelRequire('7PP2u'));